"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = (0, tslib_1.__importDefault)(require("react"));
const prop_types_1 = (0, tslib_1.__importDefault)(require("prop-types"));
const Contexts_1 = require("../Contexts");
class WithValue extends react_1.default.Component {
    render() {
        return react_1.default.createElement(Contexts_1.ValueContext.Consumer, null, value => this.props.children(value));
    }
}
exports.default = WithValue;
WithValue.propTypes = {
    children: prop_types_1.default.func
};
//# sourceMappingURL=index.js.map